import React from "react";
import { Group, Button, ActionIcon, CloseButton, Title } from "@mantine/core";
import { CustomActionButton } from "@components/custom";

export const ButtonsStylesheet = () => (
  <>
    <Title order={2} mb="md">
      Buttons
    </Title>

    {/* Standard Buttons */}
    <Group mb="md" wrap="wrap">
      <Button>Primary</Button>
      <Button variant={"secondary"}>Secondary</Button>
      <Button variant={"carrot"}>Orange</Button>
      <Button variant={"flamingo"}>Pink</Button>
      <Button variant={"ghost"}>Ghost</Button>
    </Group>

    {/* Action Icons */}
    <Group mb="md" wrap="wrap">
      <ActionIcon size="xs">
      <></>
      </ActionIcon>
      <ActionIcon size="sm">
        <></>
      </ActionIcon>
      <ActionIcon size="md">
        <></>
      </ActionIcon>
      <ActionIcon size="lg">
        <></>
      </ActionIcon>
      <ActionIcon size="xl">
        <></>
      </ActionIcon>
    </Group>

    {/* Buttons with icons */}
    <Group mb="md" wrap="wrap">
      <Button
        variant={"primary"}
        leftSection={<></>}
      >
        With Left Icon
      </Button>
      <Button
        variant={"primary"}
        rightSection={<></>}
      >
        With Right Icon
      </Button>
    </Group>

    {/* Buttons dimensions */}
    <Group mb="md" wrap="wrap">
      <Button size="xs">Extra Small</Button>
      <Button size="sm">Small</Button>
      <Button>Medium</Button>
      <Button size="lg">Large</Button>
      <Button size="xl">Extra Large</Button>
    </Group>

    {/* Icon buttons */}
    <Group mb="md" wrap="wrap">
      <Button variant={"primary-icon"} size="lg">
        <></>
      </Button>
      <Button variant={"secondary-icon"}>
        <></>
      </Button>
      <Button variant={"carrot-icon"} size="sm">
        <></>
      </Button>
      <Button variant={"flamingo-icon"} size="xs">
        <></>
      </Button>

      {/* Full width */}
      <Button fullWidth>Full Width Button</Button>

      {/* Disabled */}
      <Button disabled>Disabled</Button>

      {/* Loading */}
      <Button loading>Loading</Button>
    </Group>
    <Group wrap="wrap">
      <CloseButton variant={"ghost"} />
    </Group>

    {/* Custom Action Buttons */}
    <Title order={3} mt="xl" mb="md">
      Custom Action Buttons
    </Title>
    <Group mb="md" wrap="wrap">
      <CustomActionButton action="save">Save Changes</CustomActionButton>
      <CustomActionButton action="close">Cancel</CustomActionButton>
      <CustomActionButton action="delete">Delete Item</CustomActionButton>
    </Group>
  </>
);
